import Repository from "./Repository";

export default {
  getRefundsStates() {
    return Repository.get(`chat-refunds`);
  },
};
